import React from 'react';
import LoadingSkeleton from 'app/components/competitionModule/LoadingSkeleton';
import CompetitionModule from 'app/components/competitionModule/CompetitionModule';
import CompetitionModulePlaceholder from 'app/components/competitionModule/CompetitionModulePlaceholder';
import FuPaApiError from 'app/models/error/FuPaApiError';
import CompetitionModuleError from 'app/components/competitionModule/CompetitionModuleError';
export default function FirstCompetitionModule(_ref) {
  let {
    data,
    infiniteResult
  } = _ref;
  if (infiniteResult instanceof FuPaApiError) {
    return /*#__PURE__*/React.createElement(CompetitionModuleError, {
      errorData: infiniteResult
    });
  }
  if (infiniteResult.isLoading) {
    return /*#__PURE__*/React.createElement(LoadingSkeleton, null);
  }
  if (!data) {
    return /*#__PURE__*/React.createElement(CompetitionModulePlaceholder, null);
  }
  return /*#__PURE__*/React.createElement(CompetitionModule, {
    data: data,
    "data-sentry-element": "CompetitionModule",
    "data-sentry-component": "FirstCompetitionModule",
    "data-sentry-source-file": "FirstCompetitionModule.tsx"
  });
}